import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { PhoneTypeStatusIconsComponent } from './phone-type-status-icons.component';
import { roveHandsetIconName, roveHandsetIconSvg } from './rove-handset-icon';

@NgModule({
   declarations: [PhoneTypeStatusIconsComponent],
   imports: [CommonModule, MatIconModule, MatTooltipModule],
   exports: [PhoneTypeStatusIconsComponent],
})
export class PhoneTypeStatusIconsModule {
   // Registered here rather than in the component so it runs once per injector instead of once per row.
   constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
      iconRegistry.addSvgIconLiteral(roveHandsetIconName, sanitizer.bypassSecurityTrustHtml(roveHandsetIconSvg));
   }
}
